import { useState } from "react"
import styles from "./Expandable.module.css";



export default function Expandable({title, children}) {

    const [isOpen, setIsOpen] = useState(false);

    const handleExpandableClick = () => {
        setIsOpen(!isOpen);
    }



    if (!isOpen) return (
        <div className={styles.expandable} onClick={handleExpandableClick}>
            <span>{title}</span>
            <span>+</span>
        </div>
    );

    return (
        <>
            <div className={`${styles.expandable} ${styles.openExpandableTitle}`} onClick={handleExpandableClick}>
                <span>{title}</span>
                <span>-</span>
            </div>
            <div className={styles.expandableOpenContent}>
                {children}
            </div>
        </>

    )
}